export default __webpack_public_path__ + "static/media/FKGroteskNeue-Light.96e8cca0.woff2";